import React, { FunctionComponent } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
import moment from 'moment';

type AuditHistoryNodeProps = {
    date: string;
    description: any;
};

const AuditHistoryNode: FunctionComponent<AuditHistoryNodeProps> = (props) => {
    const { description } = props;
    const classes = makeStyles((/*theme: Theme*/) => ({
        detailNode: {
            textAlign: 'left',
            paddingLeft: 42,
            width: '80%',
            marginBottom: '1%',
        },
        detailNodeLabel: {
            fontSize: 14,
            color: gray[600],
            lineHeight: '21px',
            minWidth: 100,
        },
        detailNodeValue: {
            fontSize: 14,
            marginLeft: 20,
            color: gray[800],
            lineHeight: '21px',
        },
    }))();

    const multilineDesc = Array.isArray(description) && description;

    return (
        <Box display="flex" className={classes.detailNode}>
            <Box component="span" className={classes.detailNodeLabel}>
                {moment(props.date).format('lll')}
            </Box>
            <Box component="span" className={classes.detailNodeValue}>
                {typeof description === 'string' && description}
                {multilineDesc &&
                    multilineDesc.map((description, index) => {
                        return index === 0 ? (
                            description
                        ) : (
                            <>
                                <Box component="span" className={classes.detailNodeLabel}></Box>
                                <Box>{description}</Box>
                            </>
                        );
                    })}
            </Box>
        </Box>
    );
};

export default AuditHistoryNode;
